import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
} from '../../../components/StyledComponents';
import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import Image from 'gatsby-image';

const ImgItem = styled(Image)`
  width: 100%;
  margin-top: 6rem;
  margin-left: 2rem;
  @media (max-width: 768px) {
    margin-top: 0rem;
    margin-left: 0;
  }
`;

const ImgItemAmp = styled.img`
  width: 100%;
  margin-top: 6rem;
  margin-left: 2rem;
  @media (max-width: 768px) {
    margin-top: 0rem;
    margin-left: 0;
  }
`;

const SectionOne = styled(SectionParent)`
  padding-top: 6rem !important;
  padding-bottom: 5rem !important;
  background-color: #03103b;
  min-height: calc(100vh - 6rem);
  @media (max-width: 768px) {
    padding-top: 5rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(24, 1fr);
  display: grid;
`;

export const Title = styled.h1`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 1024px) {
    font-size: 36px;
  }
  @media (max-width: 520px) {
    font-size: 28px;
  }
`;
export const SectionOneTitle = styled(Title)`
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const GridLeft = styled.div`
  grid-column: span 11;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 24;
    padding-right: 0rem;
    margin-top: 0rem;
    margin-bottom: 3rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridRight = styled.div`
  grid-column: span 13;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 24;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.52;
  letter-spacing: normal;
  max-width: 28em;
  color: #5e92ef;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
  }
`;
const BlueButtonWrapper = styled.div`
  margin-left: -10px;
  margin-top: 2rem;
  button {
    border-radius: 8rem;
  }
  @media (max-width: 768px) {
    text-align: center;
    margin-top: 2rem;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const BottomText = styled.div`
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  display: grid;
  width: 65%;
  justify-self: center;
  padding-top: 5rem;
  @media (max-width: 1350px) and (min-width: 1050px) {
    width: 60%;
  }
  @media (max-width: 800px) {
    padding: 0;
    width: 100%;
    padding-top: 6rem;
  }
  @media (max-width: 520px) {
    font-size: 18px;
  }
`;

export default ({ messages, isAmp }: any) => (
  <div style={{ zIndex: 1, position: 'relative', background: '#f9fbfe' }}>
    <SectionOne>
      <SectionItemContainer>
        <GridLeft>
          <SectionOneTitle>{messages?.HomePageHeroText}</SectionOneTitle>
          <HeroSubTitle style={{ paddingTop: '1rem' }}>
            {messages?.HomePageHeroDescription}
          </HeroSubTitle>
          <BlueButtonWrapper>
            <Link
              to={
                messages?.locale !== 'en'
                  ? `/${messages?.locale}/signup`
                  : '/signup'
              }
            >
              <BlueButton id="get_started_homepage">
                {messages?.HomePageHeroCTA}
              </BlueButton>
            </Link>
          </BlueButtonWrapper>
        </GridLeft>
        <GridRight>
          <StaticQuery
            query={graphql`
              query {
                file(relativePath: { eq: "v2/Product/producthero.png" }) {
                  childImageSharp {
                    fluid(
                      quality: 80
                      traceSVG: { color: "#e0e4e9", threshold: 60 }
                    ) {
                      aspectRatio
                      src
                      srcSet
                      sizes
                      srcWebp
                      srcSetWebp
                      tracedSVG
                    }
                  }
                }
              }
            `}
            render={(data: any) => (
              <div style={{ alignSelf: 'center' }}>
                {isAmp ? (
                  <ImgItemAmp
                    src={data.file.childImageSharp.fluid.src}
                    srcSet={data.file.childImageSharp.fluid.srcSet}
                    alt="Think Beyond Managing Devices"
                  />
                ) : (
                  <ImgItem
                    fluid={data.file.childImageSharp.fluid}
                    alt="Think Beyond Managing Devices"
                    loading="lazy"
                  />
                )}
              </div>
            )}
          />
        </GridRight>
      </SectionItemContainer>
      <BottomText>
        {messages?.HomePageHeroSubText1}
        <br />
        <br />
        {messages?.HomePageHeroSubText2}
      </BottomText>
    </SectionOne>
  </div>
);
